export default __webpack_public_path__ + "static/media/MSSolution-infrastructure.8c0cb72c.svg";